import { useMemo } from "react";

import { matchGeoFirstAndLastCoords, useGetFieldShape } from "utils";

export const useFieldGeometry = (fieldId: string, enabled = true) => {
  const { fieldShape, fieldShapeLoading } = useGetFieldShape({ fieldId, enabled });

  const geometry = useMemo(() => (fieldShape ? { ...fieldShape, geometry: matchGeoFirstAndLastCoords(fieldShape.geometry) } : null), [fieldShape]);

  return { geometry, geometryLoading: fieldShapeLoading };
};
